// localStorage 统一管理,项目中不允许直接调用locationStorage
export const ILocalStorage = {
  clear: () => { localStorage.clear(); },
  removeItem: (key:ILocalStorageKey) => { localStorage.removeItem(key); },
  setItem: (key:ILocalStorageKey, value:string) => { localStorage.setItem(key, value); },
  getItem: (key:ILocalStorageKey):string => localStorage.getItem(key) || '',
  getLength: () => localStorage.length,
  getKey: (index:number) => localStorage.key(index),
  formatItem<T extends object>(key:ILocalStorageKey, initValue?:T):T {
    let obj = initValue || {};
    try {
      obj = JSON.parse(this.getItem(key));
    } catch (err) {
      console.log(err);
    }
    return obj as T;
  },
};

// 下面是项目中使用了localStorage的key
export enum ILocalStorageKey {
  USER_ID = 'userId',
}
